<template>
  <span @click="onFacebookShare" class="ShareFacebookButton">
    <svg xmlns="http://www.w3.org/2000/svg" width="30" height="30" viewBox="0 0 30 30">
      <g id="Group_1031" data-name="Group 1031" transform="translate(-1086 -10)">
        <rect id="Rectangle_507" data-name="Rectangle 507" width="30" height="30" transform="translate(1086 10)" fill="none"/>
        <path id="facebook-f-brands_2_" data-name="facebook-f-brands (2)" d="M3.241,19V10.5H0V7.125H3.241V4.464C3.241,1.573,5.252,0,8.189,0,9.6,0,10.8.093,11.156.134V3.154H9.119c-1.6,0-1.906.668-1.906,1.644V7.125h3.6L10.323,10.5H7.213V19" transform="translate(1096 16)" :fill="iconColor" />
      </g>
    </svg>
  </span>
</template>

<script>
import Utils from 'udn-newmedia-utils'

export default {
  name: 'ShareFacebookButton',
  props: {
    iconColor: {
      type: String,
      default: '#7b7a7a'
    },
    href: {
      type: String,
      default: window.location.href
    }
  },
  methods: {
    onFacebookShare () {
      this.handleFacebookGA()
      FB.ui({
        method: 'share',
        href: this.href,
      }, function(response){});
    },
    handleFacebookGA () {
      window.ga("send", {
        "hitType": "event",
        "eventCategory": "Share",
        "eventAction": "click",
        "eventLabel": "[" + Utils.detectPlatform() + "] [" + document.querySelector('title').innerHTML + "] [ Click_FBtop_" + document.querySelector('title').innerHTML + "]"
      })
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
.ShareFacebookButton {
  cursor: pointer;
  &:hover #facebook-f-brands_2_ {
    fill: #57b09f !important;
    transition: all .5s;
  }
}
</style>
